import React from "react"
import Cabecalho from "../Cabecalho"
import { Loading } from "../RegistradorDePedidos"
import { UsuariosPainelForm } from "./components/UsuariosPainelForm"

export function Index() {
    return (
        <>
            <Cabecalho pagina="Usuários" />
            <Loading />
            <UsuariosPainelForm />
        </>
    )
}
